<template>
    <div class="tabs-card">
        <div class="tabs-card__header">
            <h3 class="tabs-card__header-title">{{ cardTitle }}</h3>
            <span class="tabs-card__header-count" @click="countRoute">{{
                isFull ? count : ''
            }}</span>
        </div>
        <div class="tabs-card__body">
            <div
                class="tabs-card__default"
                v-if="cardType === 'default' && isFull"
                @click="toRouterPage"
            >
                <div
                    :class="{
                        'one-card': fakeCardsCount === 0,
                        'two-cards': fakeCardsCount === 1,
                        'three-cards': fakeCardsCount === 2,
                    }"
                    class="tabs-card__body-card"
                >
                    <div class="tabs-card__body-card-top">
                        <div class="tabs-card__body-card-top-img">
                            <img
                                :src="
                                    imgLink ||
                                    require('../../assets/images/no-picture.svg')
                                "
                                alt="Photo"
                            />
                        </div>

                        <div class="tabs-card__body-card-top-info">
                            <h4 class="tabs-card__body-card-top-info-title">
                                {{ infoTitle | ellipsis(isMobile ? 70 : 100) }}
                            </h4>
                            <!-- <div v-html="infoDescription" class="tabs-card__body-card-top-info-description" /> возможно понадобится приветствие -->
                        </div>
                    </div>
                    <div class="tabs-card__body-card-bottom">
                        <img
                            class="tabs-card__body-card-bottom-img"
                            src="~@/assets/images/tabs-card-play.svg"
                            alt="Continiue"
                        />
                        <span class="tabs-card__body-card-bottom-link">{{
                            continueBtnText
                        }}</span>
                    </div>
                </div>
                <div
                    :class="{ 'one-fake-card': fakeCardsCount === 1 }"
                    class="tabs-card__body-fake-card"
                    v-for="item in fakeCardsCount"
                    :key="item"
                ></div>
            </div>
            <div
                class="tabs-card__empty"
                v-if="cardType === 'default' && !isFull"
            >
                <img class="tabs-card__empty-img" :src="emptyImgLink" />
                <div class="tabs-card__empty-text">
                    <div class="tabs-card__empty-oops">Oops!</div>
                    <div class="tabs-card__empty-warning">{{ emptyText }}</div>
                </div>
            </div>
            <div
                class="tabs-card__reports"
                v-if="cardType === 'reports' && isFull"
            >
                <a
                    class="tabs-card__reports-link"
                    v-for="item in items"
                    :key="item.uid"
                    target="_blank"
                    :href="item.fullPdfLink"
                >
                    <img :src="item.fullImgLink" />
                    <h4 class="tabs-card__reports-title">
                        {{ item.testName }}
                    </h4>
                </a>
            </div>
            <div
                class="tabs-card__reports-empty"
                v-if="cardType === 'reports' && !isFull"
            >
                <div class="tabs-card__reports-empty-text">
                    У вас пока нет персональных отчетов
                </div>
            </div>
        </div>
        <div class="tabs-card__footer">
            <div
                v-if="!(cardType === 'reports' && !isFull)"
                :class="{ 'btn-link': !isFull }"
                class="tabs-card__footer-link-wrapper"
                @click="toFullLink"
            >
                <span class="tabs-card__footer-link">{{
                    isFull ? toFullBtnText : btnText
                }}</span>
                <img
                    v-if="isFull"
                    class="tabs-card__footer-img"
                    src="~@/assets/images/tabs-card-arrow-right.svg"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = ['isMobile'];

export default {
    props: {
        count: {
            type: [Number, String],
            default: '',
        },
        cardType: {
            type: String,
            default: 'default', // may be reports
        },
        cardTitle: {
            type: String,
            default: '',
        },
        isDataFull: {
            type: Boolean,
            defalut: false,
        },
        emptyText: {
            type: String,
            default: '',
        },
        emptyImgLink: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        infoTitle: {
            type: String,
            default: '',
        },
        imgLink: {
            type: String,
            default: '',
        },
        selectBtnLink: {
            type: String,
            default: '',
        },
        infoDescription: {
            type: String,
            default: '',
        },
        toFullRouter: {
            type: String,
            default: '',
        },
        cardRouter: {
            type: String,
            default: '',
        },
        lmsLink: {
            type: String,
            default: '',
        },
        toFullBtnText: {
            type: String,
            default: '',
        },
        continueBtnText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            btnText: 'Подобрать',
        };
    },
    methods: {
        toFullLink() {
            if (this.isFull) {
                this.$router.push({ path: this.toFullRouter });
            } else {
                window.location = this.selectBtnLink;
            }
        },
        countRoute() {
            this.$router.push({ path: this.toFullRouter });
        },
        toRouterPage() {
            if (this.lmsLink) {
                window.location = this.lmsLink;
            } else if (this.cardRouter) {
                this.$router.push(this.cardRouter);
            }
        },
    },
    computed: {
        ...mapGetters(getters),
        fakeCardsCount() {
            if (this.count >= 3) {
                return 2;
            } else if (this.count === 2) {
                return 1;
            } else {
                return 0;
            }
        },
        isFull() {
            return this.isDataFull || false;
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';

.tabs-card {
    font-family: 'Circe Rounded';
    background: #ffffff;
    box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
    border-radius: mrem(4);
    padding: mrem(20);

    @include on-desktop {
        box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
        border-radius: rem(10);
        padding: rem(30);
    }
    &__body-card-top-info {
        margin: auto 0;
    }
    &__empty {
        display: flex;
        align-items: center;
        padding-left: mrem(22);

        @include on-desktop {
            justify-content: left;
            padding-left: rem(200);
            margin-top: rem(-35);
        }

        &-img {
            @include on-desktop {
                width: rem(85);
                height: rem(81);
            }
        }

        &-text {
            font-family: 'Circe Rounded';
            font-style: normal;
            font-weight: normal;
            font-size: mrem(16);
            line-height: mrem(22);
            margin-left: mrem(24);
            color: #9fb7e3;

            @include on-desktop {
                margin-left: rem(24);
                font-size: rem(16);
                line-height: rem(22);
            }
        }

        &-oops {
            font-weight: bold;
        }
    }

    &__default {
        margin-left: mrem(22);
        position: relative;

        @include on-desktop {
            margin-left: rem(0);
        }
    }

    &__reports {
        display: flex;
        justify-content: center;
        margin-bottom: mrem(16);

        @include on-desktop {
            justify-content: initial;
            width: 100%;
            margin-bottom: rem(16);
        }

        &-title {
            font-style: normal;
            font-weight: 400;
            font-size: mrem(16);
            line-height: mrem(24);
            width: mrem(165);
            margin: mrem(17) 0 0 0;
            text-align: center;
            color: #000000;

            @include on-desktop {
                width: rem(155);
                margin: rem(17) 0 0 0;
                font-size: rem(16);
                line-height: rem(24);
            }
        }

        &-empty {
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 600;
            font-size: mrem(15);
            line-height: mrem(22);
            color: #9fb7e3;

            @include on-desktop {
                font-size: rem(15);
                line-height: rem(22);
            }
        }

        &-link {
            display: none;

            &:first-child {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-left: rem(0);
            }

            @include on-desktop {
                display: block;
                margin-left: rem(28);
            }

            img {
                @include on-desktop {
                    width: rem(155);
                    height: rem(110);
                }
            }
        }
    }

    &__header {
        display: flex;
        margin: mrem(0) mrem(0) mrem(16) mrem(0);

        @include on-desktop {
            margin: rem(0) rem(0) rem(16) rem(0);
        }

        font-family: Montserrat, sans-serif;

        &-title {
            font-style: normal;
            line-height: mrem(32);
            display: flex;
            align-items: center;
            color: #2a2626;
            flex: none;
            order: 0;
            flex-grow: 0;
            margin: mrem(0);
            font-weight: 600;
            font-size: mrem(22);

            @include on-desktop {
                font-size: rem(20);
                line-height: rem(32);
                margin: rem(0);
                font-weight: 700;
            }
        }

        &-count {
            font-size: mrem(18);
            line-height: mrem(26);
            margin-left: mrem(8);
            display: flex;
            align-items: center;
            text-align: center;
            color: #2a2626;

            @include on-desktop {
                font-size: rem(18);
                line-height: rem(26);
                margin-left: rem(8);

                &:hover {
                    text-decoration: underline;
                    text-decoration-color: #4663ab;
                    cursor: pointer;
                }
            }
        }
    }

    &__body {
        position: relative;

        &-card {
            position: relative;
            z-index: 1;
            cursor: pointer;
            width: mrem(260);
            padding: mrem(20);
            background: #f6f9ff;
            box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
            border-radius: mrem(10);

            @include on-desktop {
                height: rem(230);
                width: rem(677);
                padding: rem(20);
                box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
                border-radius: rem(10);

                &:hover {
                    box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.2);
                }
            }

            &-top {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-bottom: mrem(16);

                @include on-desktop {
                    flex-direction: row;
                    display: flex;
                    justify-content: left;
                    align-items: flex-start;
                    margin-bottom: rem(16);
                }

                &-img {
                    background: #ffffff;
                    min-width: mrem(220);
                    max-width: mrem(220);
                    height: mrem(124);
                    border-radius: mrem(10);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                    padding: 10px 23px;

                    @include on-desktop {
                        min-width: rem(220);
                        max-width: rem(220);
                        height: rem(124);
                        border-radius: rem(10);
                        margin-right: rem(20);
                    }
                    img {
                        border-radius: 4px;
                        width: 100%;
                    }
                }

                &-info {
                    display: block;

                    @include on-desktop {
                        display: block;
                    }

                    &-title {
                        font-size: mrem(18);
                        line-height: mrem(25);
                        height: mrem(75);
                        width: mrem(200);
                        text-align: center;
                        overflow: hidden;

                        @include on-desktop {
                            font-weight: bold;
                            max-height: rem(75);
                            height: inherit;
                            overflow: hidden;
                            text-align: left;
                            width: inherit;
                            font-size: rem(21);
                            line-height: rem(25);
                            color: #000000;
                            margin: rem(0) rem(0) rem(14) rem(0);
                        }
                    }

                    &-description {
                        display: none;

                        @include on-desktop {
                            display: block;
                            height: rem(58);
                            overflow: hidden;
                            font-style: normal;
                            font-weight: 350;
                            font-size: rem(16);
                            line-height: rem(20);
                            color: #2a2626;
                        }
                    }
                }
            }

            &-bottom {
                display: flex;
                align-items: center;
                justify-content: center;

                @include on-desktop {
                    display: block;
                    position: absolute;
                    bottom: rem(20);
                }

                &-img {
                    width: mrem(20);
                    height: mrem(20);
                    margin-right: mrem(10);

                    @include on-desktop {
                        width: rem(20);
                        height: rem(20);
                        margin-right: rem(10);
                    }
                }

                &-link {
                    color: #000000;
                    font-style: normal;
                    font-weight: normal;
                    font-size: mrem(18);
                    line-height: mrem(26);

                    @include on-desktop {
                        font-size: rem(18);
                        line-height: rem(26);
                    }
                }
            }
        }

        &-fake-card {
            width: mrem(260);
            height: mrem(330);
            position: absolute;
            top: mrem(30);
            left: mrem(30);
            padding: mrem(20);
            background: #f6f9ff;
            box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
            border-radius: mrem(10);

            &:last-child {
                position: absolute;
                left: mrem(16);
                top: mrem(16);

                @include on-desktop {
                    left: rem(16);
                    top: rem(16);
                }
            }

            @include on-desktop {
                width: rem(677);
                height: rem(230);
                top: rem(30);
                left: rem(30);
                padding: rem(20);
                box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
                border-radius: rem(10);
            }
        }
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: mrem(18);
        line-height: mrem(26);
        color: #4663ab;

        @include on-desktop {
            justify-content: flex-end;
            font-size: rem(18);
            line-height: rem(26);
        }

        &-img {
            width: mrem(8);
            height: mrem(12);

            @include on-desktop {
                width: rem(8);
                height: rem(12);
            }
        }

        &-link {
            display: inline-block;
            margin-right: mrem(9);

            @include on-desktop {
                margin-right: rem(9);
            }

            &-wrapper {
                @include on-desktop {
                    border: 1px solid transparent;
                    cursor: pointer;

                    &:hover {
                        border-bottom: 1px solid #4663ab;
                    }
                }
            }
        }
    }
}

.one-card {
    width: mrem(315);
    margin-bottom: mrem(16);

    @include on-desktop {
        width: 100%;
        margin-bottom: rem(16);
    }
}

.two-cards {
    width: mrem(270);
    margin-bottom: mrem(32);

    @include on-desktop {
        width: rem(692);
        margin-bottom: rem(32);
    }
}

.three-cards {
    margin-bottom: mrem(48);

    @include on-desktop {
        margin-bottom: rem(48);
    }
}

.one-fake-card {
    width: mrem(270);

    @include on-desktop {
        width: rem(692);
    }
}

.btn-link {
    font-size: mrem(18);
    line-height: mrem(26);
    text-align: center;
    margin-top: mrem(16);
    color: #ffffff;
    padding: mrem(10) mrem(16);
    width: mrem(123);
    height: mrem(46);
    background: #4663ab;
    border-radius: mrem(4);

    @include on-desktop {
        margin-top: 0;
        font-size: rem(18);
        line-height: rem(26);
        padding: rem(10) rem(16);
        width: rem(123);
        height: rem(46);
        border-radius: rem(4);
    }
}
</style>
